import { render, staticRenderFns } from "./ChargeRatesList.vue?vue&type=template&id=8ca60406&scoped=true&"
import script from "./ChargeRatesList.vue?vue&type=script&lang=js&"
export * from "./ChargeRatesList.vue?vue&type=script&lang=js&"
import style0 from "./ChargeRatesList.vue?vue&type=style&index=0&id=8ca60406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca60406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ca60406')) {
      api.createRecord('8ca60406', component.options)
    } else {
      api.reload('8ca60406', component.options)
    }
    module.hot.accept("./ChargeRatesList.vue?vue&type=template&id=8ca60406&scoped=true&", function () {
      api.rerender('8ca60406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChargeRatesList.vue"
export default component.exports